import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/queue/queueList",
  name: "queueList",
  component: function component() {
    return import("../../../views/queueUp/queueList.vue");
  },
  meta: {
    title: "扫码排队",
    foot: true
  }
}, {
  path: "/queue/queueDetails/:id",
  name: "queueDetails",
  component: function component() {
    return import("../../../views/queueUp/queueDetails.vue");
  },
  meta: {
    title: "扫码排队",
    foot: true
  }
}];